<template>
  <div>
    <HearderTitle name="修改密码" />
    <div class="content">
      <el-form class="form_box" ref="user" :rules="rules" :model="userData" label-width="80px">
        <el-form-item label="昵称" prop="nickname">
          <el-input type="text" v-model="userData.nickname" disabled autofocus></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input type="password" v-model="userData.password"></el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="rePassword">
          <el-input type="password" v-model="userData.rePassword"></el-input>
        </el-form-item>
        <el-form-item>
          <input type="text" v-model="userData.id" hidden />
          <el-button class="lightBlueBtn searchBtn" type="primary" size="small" @click="seve()">提交</el-button>
          <el-button size="small" plain class="searchBtn" @click="$refs['user'].resetFields()">取消</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
  import HearderTitle from '@/components/HearderTitle'
  import { editUser } from '@/api/user.js'
  export default {
    name: 'editPassword',
    data() {
      const validatePass2 = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请再次输入密码'))
        } else if (value !== this.userData.password) {
          callback(new Error('两次输入密码不一致!'))
        } else {
          callback()
        }
      }
      return {
        userDialog: false,
        userData: {
          nickname: '',
          id: '',
          password: '',
          rePassword: '',
        },
        rules: {
          nickname: [{ required: true, message: '昵称不能为空', trigger: 'blur' }],
          username: [
            {
              required: true,
              message: '请输入用户名',
              trigger: 'blur',
            },
            {
              min: 2,
              max: 12,
              message: '长度在 2 到 12 个字符',
              trigger: 'blur',
            },
            { required: true, message: '账号不能为空', trigger: 'blur' },
          ],
          password: [
            {
              min: 6,
              max: 15,
              message: '长度在 6 到 15 个字符',
              trigger: 'blur',
            },
            { required: true, message: '密码不能为空', trigger: 'blur' },
          ],
          rePassword: [
            { required: true, message: '确认密码不能为空', trigger: 'blur' },
            { validator: validatePass2, trigger: 'blur' },
          ],
        },
      }
    },
    components: { HearderTitle },
    created() {
      this.userData.id = JSON.parse(sessionStorage.userInfo).id
      this.userData.nickname = JSON.parse(sessionStorage.userInfo).nickname
    },
    methods: {
      async seve() {
        this.$refs['user'].validate(async (valid) => {
          if (!valid) return
          let { nickname, password, id } = this.userData
          let res = await editUser({ nickname, password, id })
          if (res.status !== 200) return this.$message.error(res.msg)
          this.$message.success('提交成功')
        })
      },
    },
  }
</script>

<style lang="less" scoped>
  .content {
    min-height: 780px;
  }
  .form_box {
    margin-top: 45px;
    width: 385px;
    .searchBtn {
      width: 112px;
    }
  }
</style>
